import React, { useState } from 'react';
import { ErrorMessage, Formik, FormikConfig } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { useQuery } from '../helpers/useQuery';
import LogoPage from './LogoPage';
import './ResendLinkPage.scss';
import { SendMagicLinkEmailRequest } from '../models/dto/magicLinkRequest';

const validationSchema = yup.object({
	email: yup.string().required('Email is required').email('Email is invalid')
});

export default function ResendLinkPage() {
	const query = useQuery();
	const [state, setState] = useState<State>({ type: 'resend', hasError: !!query.get('error') });
	
	return (
		<LogoPage>
			<div className="resend-link-page__container">
				{state.type === 'resend' &&
				<React.Fragment>
					{state.hasError && <div className="text-red mb-1">This access link is invalid.</div>}
					<div className="mb-2">Please enter your email address</div>

					<Formik {...getFormikConfig()} >
						{({ handleSubmit, values, isSubmitting, handleChange, handleBlur }) => (
							<form onSubmit={handleSubmit} noValidate={true}>
								<input type="email"
									   name="email"
									   className="text-input"
									   onChange={handleChange}
									   onBlur={handleBlur}
									   value={values.email} />

								<ErrorMessage name="email">
									{msg => <div className="text-red mt-1 text-small">{msg}</div>}
								</ErrorMessage>

								<div className="mt-2">
									<button className="btn btn_full" type="submit" disabled={isSubmitting || !values.email}>Next</button>
								</div>
							</form>
						)}
					</Formik>
				</React.Fragment>
				}

				{state.type === 'resent' &&
				<React.Fragment>
					<div className="text-bold mb-2">If an account exists with the email you entered, you'll receive an access link shortly.</div>
					<div className="text-small">
						<span className="text-light">Didn't recieve an email? Check your spam folder or</span>
						<a role="button" onClick={() => setState({ type: 'resend', hasError: false })}> try again</a>
						<span className="text-light">. You can also contact</span>
						<a href="mailto:support@tethr.com"> support@tethr.com </a>
						<span className="text-light">for additional help.</span>
					</div>
				</React.Fragment>
				}
			</div>
		</LogoPage>
	);

	function getFormikConfig(): FormikConfig<ResendValues> {
		return {
			initialValues: { email: '' },
			onSubmit: (values) => {
				const request: SendMagicLinkEmailRequest = { email: values.email };
				return axios.post<void>(`/api/token/send-link`, request).then(() => {
					setState({ type: 'resent', email: request.email });
				});
			},
			validationSchema
		}
	}
}

type State = { type: 'resend'; hasError: boolean; } | { type: 'resent'; email: string; };

interface ResendValues {
	email: string;
}